import { call, put, select, takeLatest } from 'redux-saga/effects'
import { callApi } from '@/shared/tools/apiSagaHelperV2'
import {
  updateHomeData,
  updateHomeError,
  updateHomeIsLoading,
  setIsEditingWelcomeMessage,
  setIsEditingSpeedFormation,
  updateWelcomeMessageSaveStatus,
  updateSpeedFormationSaveStatus,
} from '@/containers/HomePage/HomeSlice'
import { selectHomeData } from '@/containers/HomePage/HomeSelectors'

export const homeActions = {
  INITIALIZE_HOME: 'INITIALIZE_HOME',
  SAVE_WELCOME_MESSAGE: 'SAVE_WELCOME_MESSAGE',
  SAVE_SPEED_FORMATION: 'SAVE_SPEED_FORMATION',
}

export function* initializeHomeSaga({ endpoint }) {
  try {
    yield put(updateHomeIsLoading(true))

    const data = yield call(callApi, { endpoint })

    yield put(updateHomeData(data))
  } catch (error) {
    yield put(updateHomeError(error.message))
  } finally {
    yield put(updateHomeIsLoading(false))
  }
}

export function* saveWelcomeMessageSaga({ text }) {
  try {
    yield put(updateWelcomeMessageSaveStatus({ isLoading: true, error: null, errorMessage: null }))

    const data = yield select(selectHomeData)
    const endpoint = data.editWelcomeMessageUrl ?? ''

    yield call(callApi, {
      endpoint,
      method: 'POST',
      payload: { text },
    })

    yield put(updateHomeData({ ...data, welcomeMessage: text }))
    yield put(updateWelcomeMessageSaveStatus({ isLoading: false, error: false, errorMessage: null }))
    yield put(setIsEditingWelcomeMessage(false))
  } catch (error) {
    yield put(updateWelcomeMessageSaveStatus({
      isLoading: false,
      error: true,
      errorMessage: error.message,
    }))
  }
}

export function* saveSpeedFormationSaga({ text, date }) {
  try {
    yield put(updateSpeedFormationSaveStatus({ isLoading: true, error: null, errorMessage: null }))

    const data = yield select(selectHomeData)
    const endpoint = data.editSpeedFormationUrl ?? ''

    yield call(callApi, {
      endpoint,
      method: 'POST',
      payload: { speed_training_text: text, speed_training_end_date: date },
    })

    yield put(updateHomeData({ ...data, speedFormation: { text, date } }))
    yield put(updateSpeedFormationSaveStatus({ isLoading: false, error: false, errorMessage: null }))
    yield put(setIsEditingSpeedFormation(false))
  } catch (error) {
    yield put(updateSpeedFormationSaveStatus({ isLoading: false, error: true, errorMessage: error.message }))
  }
}

export default function* homeSagas() {
  yield takeLatest(homeActions.INITIALIZE_HOME, initializeHomeSaga)
  yield takeLatest(homeActions.SAVE_WELCOME_MESSAGE, saveWelcomeMessageSaga)
  yield takeLatest(homeActions.SAVE_SPEED_FORMATION, saveSpeedFormationSaga)
}
